"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registry = void 0;
exports.getNamespace = getNamespace;
exports.getFieldDef = getFieldDef;
exports.getSectionLabels = getSectionLabels;
exports.listNamespaces = listNamespaces;
// packages/shared/src/content/registry.ts
const registry_generated_1 = require("./registry.generated");
const overrides_1 = require("./overrides");
function buildRegistry() {
    const out = {};
    for (const [ns, def] of Object.entries(registry_generated_1.generatedRegistry)) {
        const fields = {};
        for (const [key, fieldDef] of Object.entries(def.fields)) {
            fields[key] = {
                type: overrides_1.fieldTypeOverrides[ns]?.[key] ?? fieldDef.type,
                label: overrides_1.labelOverrides[ns]?.[key] ?? fieldDef.label,
                section: overrides_1.sectionOverrides[ns]?.[key],
            };
        }
        out[ns] = { ...def, fields };
    }
    return out;
}
exports.registry = buildRegistry();
function getNamespace(page) {
    return exports.registry[page];
}
function getFieldDef(page, key) {
    return exports.registry[page]?.fields[key];
}
function getSectionLabels(page) {
    return overrides_1.sectionLabels[page];
}
function listNamespaces() {
    return Object.entries(exports.registry).map(([page, def]) => ({
        page,
        label: def.label,
        group: def.group,
    }));
}
//# sourceMappingURL=registry.js.map